import { memo, useEffect, useMemo } from 'react'

import { createAppError, reportError } from '@/lib/errors'

import View from './AppErrorState.view'

export interface ControllerProps {
  denied?: boolean
  error?: unknown
  onRetry?: () => void
}

export const Controller = memo(function AppErrorStateController({ denied = false, error, onRetry }: ControllerProps) {
  const deniedError = useMemo(() => createAppError('Administrator privileges required', { code: 'ADMIN_REQUIRED' }), [])
  useEffect(() => {
    reportError(denied ? deniedError : error, {
      operation: denied ? 'Open administrator page' : 'Render application page'
    })
  }, [denied, deniedError, error])

  return <View denied={denied} onRetry={onRetry} onHome={() => window.location.assign('/')} />
})

Controller.displayName = 'AppErrorState_Controller'
